import React from "react";
import { Translation } from "../../core/translate";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../redux/brand";
import styled from "styled-components";

const GraphicContainer = styled.div`
  width: 315px;
  padding: 0 40px;
  object {
    margin-left: -20px;
  }
  img {
    max-width: 100%;
  }
`;

const Graphic = ({ watkinsEnabled, image, bookCover }) => {
  if (!image) {
    return <GraphicContainer />;
  }
  if (bookCover) {
    return (
      <GraphicContainer role="presentation">
        <img
          src={`${Fraction.Environment.coversHost}/vbid/${bookCover}/width/200`}
        />
      </GraphicContainer>
    );
  }
  let imgObject = (
    <object
      type="image/svg+xml"
      data={image.path}
      className="logo"
      aria-hidden={true}
      tabIndex={-1}
    >
      <Translation id="signin.signin-graphic" />
    </object>
  );
  if (!image.svg) {
    imgObject = <img src={image.path} alt="" role="presentation" />;
  }
  // If watkins is off and logo is still watkins, don't show a logo
  if (image.watkins && !watkinsEnabled) {
    imgObject = null;
  }
  imgObject = Fraction.Helpers.holidayWatkins() || imgObject;
  return <GraphicContainer role="presentation">{imgObject}</GraphicContainer>;
};

const getImageDetails = (state, page = "signin") => {
  let imagePath =
    brandSelectors.getBrandValue(state, `Graphics.${page}`, "") || "";
  const watkins = imagePath.length === 0;
  if (watkins) {
    switch (page) {
      case "signin":
        imagePath = "/img/watkins_welcome.svg";
        break;
      case "register":
      case "forgot":
        imagePath = "/img/watkins_register_scribbles.svg";
        break;
      case "sad":
        imagePath = "/img/watkins_frowny.svg";
        break;
    }
  }
  return {
    path: imagePath,
    svg: imagePath.indexOf(".svg") >= 0,
    watkins
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    image: getImageDetails(state, ownProps.page),
    watkinsEnabled: brandSelectors.getBrandValue(
      state,
      "Graphics.watkins",
      true
    )
  };
};

export default connect(mapStateToProps)(Graphic);
